import ApplicationGuideLink from './ApplicationGuideLink';
export { ApplicationGuideLink };
export default ApplicationGuideLink;
